export const ALL_NODE_KEY = '__ALL';

// pageServer 注入，指定路由 csr 链路，对应用启动流程精简
// export const IS_SIMPLE_PAGE = /*#__PURE__*/ (() => window.isLightBaseRoute)();

// PWA 场景下，立刻下发静态模版缓存，如果依赖 bff 判断路径再注入会阻塞基座加载
export const IS_SIMPLE_PAGE = (() =>
  window.isLightBaseRoute ||
  ['/b/trial', '/tenant', '/b/login', '/b/coworker-invite'].some(path =>
    window.location.pathname.startsWith(path),
  ))();
